import { useLocaleState } from 'react-admin';

export const useBackendTranslate = () => {
  const getTranslation = (item: any, key: string) => {
    const [lang] = useLocaleState();
    const langArr = ['da', 'en', 'sv'];
    const translation = item?.translations?.filter(
      (c: any) => c?.languageId === langArr.indexOf(lang) + 1 && c?.key === key
    );

    if (lang !== 'da') {
      return item && translation ? translation[0]?.value : item[key];
    }
    return item[key];
  };

  return getTranslation;
};
